import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    blogs: [],
    authors: [],
    page: 1,
    page_size: 10,
    order_column: 'created_at',
    order_type: 'desc',
    dialog: false,
    blog: {
      id: null,
      name: null,
      title: null,
      subtitle: null,
      publish_time: null,
      text: null,
      short_text: null,
      image_url: null
    }
  },

  mutations: {
    setBlogs(state, payload) {
      state.blogs = payload
    },
    setAuthors(state, payload) {
      state.authors = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setSelectedBlog(state, payload) {
      state.blog = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    }
  },

  actions: {
    read({ commit, state }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/blog', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type
          }
        })
        .then(r => {
          commit('setBlogs', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    getAuthors({ commit }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/blog-author')
        .then(r => {
          commit('setAuthors', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    update({ commit, dispatch, state }, id) {
      axios.admin
        .put('cms/blog/' + id, {
          author_id: state.blog.author_id,
          title: state.blog.title,
          subtitle: state.blog.subtitle,
          publish_time: state.blog.publish_time,
          text: state.blog.text,
          short_text: state.blog.short_text,
          image_url: state.blog.image_url
        })
        .then(() => {
          commit('setDialog', false)
          commit('setSelectedBlog', {})
          dispatch('read')
        })
    },
    delete({ dispatch }, id) {
      axios.admin.put('cms/blog/delete/' + id).then(() => {
        dispatch('read')
      })
    },
    publish({ dispatch }, id) {
      axios.admin.put('cms/blog/publish/' + id).then(() => {
        dispatch('read')
      })
    },
    unpublish({ dispatch }, id) {
      axios.admin.put('cms/blog/unpublish/' + id).then(() => {
        dispatch('read')
      })
    },
    insert({ commit, dispatch, state }) {
      axios.admin
        .post('cms/blog', {
          author_id: state.blog.author_id,
          title: state.blog.title,
          subtitle: state.blog.subtitle,
          text: state.blog.text,
          short_text: state.blog.short_text,
          image_url: state.blog.image_url
        })
        .then(() => {
          commit('setDialog', false)
          commit('setSelectedBlog', {})
          dispatch('read')
        })
    }
  }
}
